import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { goals } from '../data/content';
export function GoalSection() {
  return <section aria-labelledby="meta" className="bg-white" data-id="element-74" data-mp="3dklp8923uzd3">
      <div className="mx-auto max-w-page px-3 py-5 text-center sm:px-6 sm:py-7" data-id="element-75" data-mp="3sa12qncml8au">
        <Reveal data-id="element-76" data-mp="3nbzku5qxrf0y">
          <h2 id="meta" className="mx-auto max-w-3xl font-display text-lg uppercase leading-[1.06] text-navy sm:text-2xl lg:text-3xl" data-id="element-77" data-mp="3ndkd1ops2lvn">
            🎯 De “no sé por dónde empezar” a comprender las bases de un
            proyecto fotovoltaico
          </h2>
          <p className="mt-1 text-[0.74rem] font-black uppercase tracking-[0.16em] text-azure sm:text-[0.82rem]" data-id="element-78" data-mp="38oef042of1pc">
            Al completar el sistema tendrás una base para:
          </p>
        </Reveal>

        <ul className="mx-auto mt-2.5 grid max-w-4xl gap-1.5 text-left sm:grid-cols-2" data-id="element-79" data-mp="nvt4yahif5bw">
          {goals.map((goal, i) => <Reveal key={goal} as="li" delay={i * 0.03} className="flex items-start gap-2 rounded-md border border-azure/25 bg-azure-soft px-2.5 py-2 font-body text-[0.78rem] font-semibold leading-snug text-navy sm:text-[0.82rem]" data-id="element-80" data-mp="jxlolgqyk618" data-mpi={i}>
              <CheckIcon size={15} className="mt-0.5 flex-shrink-0 text-azure" strokeWidth={3} data-id="element-81" data-mp="2q08nejxv5y7j" />
              {goal}
            </Reveal>)}
        </ul>

        <Reveal delay={0.08} className="mx-auto mt-3 max-w-2xl" data-id="element-82" data-mp="22cqu2jyyas2g">
          <p className="font-body text-[0.8rem] leading-snug text-steel sm:text-sm" data-id="element-83" data-mp="22d0i420fqp5i">
            No necesitas memorizar cientos de páginas técnicas.{' '}
            <span className="font-bold text-navy" data-id="element-84" data-mp="2c2ttb1wo1298">
              Necesitas comprender qué hace cada componente, cómo se relacionan
              entre sí y qué aprender primero.
            </span>
          </p>
        </Reveal>
      </div>
    </section>;
}